import React, {useContext, useEffect, useState} from 'react'
import {isNotEmpty, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {createCategoryMaster, duplicateData} from '../category-master-list/core/_requests'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {useQueryResponse} from '../category-master-list/core/QueryResponseProvider'
import {getExCRUD} from '../../role-access/role-setting-list/core/_requests'

export interface IProfileDetails {
  name: string
  createdBy: string | undefined
}

export let initialValues: IProfileDetails = {
  name: '',
  createdBy: '',
}

const roleDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Category master name is required'),
})

const RoleDetails: React.FC = () => {
  const {showAlert} = useContext(AlertContext)
  const {refetch} = useQueryResponse()
  const [data, setData] = useState<IProfileDetails>(initialValues)
  const navigate = useNavigate()
  const {currentUser} = useAuth()

  const [loading, setLoading] = useState(false)
  const [Duplicate, setDuplicate] = useState<any>('')

  // Duplicate check function
  const DuplicateCheck = async (val: string) => {
    try {
      const value = {
        name: val,
      }
      if (val.length >= 3) {
        const response = await duplicateData(value)
        console.log('response?.isDuplicate', response?.isDuplicate)
        if (response?.isDuplicate === true) {
          setDuplicate('Category master already exists')
        } else {
          setDuplicate('')
        }
      }
    } catch (error) {
      console.error('Error checking for duplicate user type:', error)
    }
  }

  // Integrating both Formik's handleChange and DuplicateCheck in one function
  const handleNameChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    formik.setFieldValue('name', value) // Updates Formik's field value
    await DuplicateCheck(value) // Performs the duplicate check
  }

  const formik = useFormik<IProfileDetails>({
    initialValues,
    validationSchema: roleDetailsSchema,
    onSubmit: (values, {resetForm}) => {
      setLoading(true)
      const updatedData = {...data, ...values}
      updatedData.createdBy = currentUser?.userId

      createCategoryMaster(updatedData).then((res) => {
        initialValues = {
          name: '',
          createdBy: '',
        }
        resetForm({
          ...initialValues,
          values: {...initialValues},
        })
        setData(initialValues)
        navigate('/categoryMaster/list', {replace: true})
        refetch()
        setLoading(false)
        showAlert(res?.Message, res?.Code)
      })
    },
    enableReinitialize: true,
  })

  const [roleaccess, setroleaccess] = useState<any>([])
  useEffect(() => {
    getExCRUD(currentUser?.roleId, 5).then((res: any) => {
      var crudres = res.data?.Data[0]
      setroleaccess(crudres)
    })
  }, [])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Add Category Master </h3>
        </div>
      </div>

      <div id='kt_account_profile_details'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/** Category Name Field */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg-12 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Category Name</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Enter Category Name'
                    {...formik.getFieldProps('name')}
                    onChange={handleNameChange} // Combined handleChange and DuplicateCheck
                  />
                  {Duplicate && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{Duplicate}</div>
                    </div>
                  )}
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            {roleaccess?.add === 1 && (
              <button type='submit' className='btn btn-primary' disabled={loading || !!Duplicate}>
                {!loading && 'Save Changes'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}

export default RoleDetails
